import { Component } from '@angular/core';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { SearchComponent } from '../../components/common/search/search.component';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { BookedEventSummaryDto } from '../../models/training/training.models';
import { TrainingSearchModel, TrainingSummaryDto } from '../../models/training/training.search.models';
import { TrainingService } from '../../services/training.service';

@Component({
    selector: 'resources',
    template: require('./resources.component.html'),
    styles: [require('./resources.component.css')]
})
export class ResourcesComponent extends SearchComponent<TrainingSearchModel, TrainingSummaryDto> {

    bookedEvents: BookedEventSummaryDto[];
    subscribed: boolean;

    constructor(private trainingService: TrainingService,
        configuration: Configuration,
        helpers: Helpers,
        loggedInUserService: LoggedInUserService,
    ) {
        super(new TrainingSearchModel(configuration), trainingService, helpers);
        var user = loggedInUserService.getCurrentUser();
        this.subscribed = !user.canAdHoc('notSubscribed');
    }

    ngOnInit() {
        super.ngOnInit();
    }

    copyToClipboard(element) {
        element.select();
        document.execCommand('copy');
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/resources/resources.component.ts